<app-outbound-fax-search-form (faxSearch)="onSearch($event)" />
@if (!refreshing && hasQueried && hasResults) {
  <div class="mt-4">
    <div>
      <strong>Please select an <em>outbound</em> fax</strong>
    </div>
    <table class="table table-bordered table-sm small">
      <thead class="table-dark">
        <tr>
          <th>DATE FAXED</th>
          <th>CLIENT</th>
          <th>PATIENT</th>
          <th>PRESCRIBER</th>
          <th>OFFICE</th>
          <th>FAX NUMBER</th>
          <th>OUTBOUND STATUS</th>
          <th>INBOUND STATUS</th>
          <th>PROVIDER FAX STATUS</th>
          <th>FAX TYPE</th>
        </tr>
      </thead>
      <tbody>
        @for (outboundFax of outboundFaxes; track outboundFax) {
          <tr>
            <td>
              <div class="form-check">
                <input
                  [id]="'outboundFax' + outboundFax.id"
                  name="selectedOutboundFaxId"
                  class="form-check-input"
                  type="radio"
                  (change)="onOutboundFaxChange(outboundFax)"
                  [value]="outboundFax.id"
                  [disabled]="outboundFax.hasValidEvidence"
                  />
                <label
                  class="form-check-label pt-1"
                  [ngClass]="{ disabled: outboundFax.hasValidEvidence }"
                  [for]="'outboundFax' + outboundFax.id"
                  >
                  {{ outboundFax.createdAt | date: 'MM/dd/yyyy' }}
                </label>
              </div>
            </td>
            <td>{{ outboundFax.client.humanizedName }}</td>
            <td>
              <app-patient-name [patient]="outboundFax.patient" />
            </td>
            <td><app-prescriber-name [provider]="outboundFax.provider" /></td>
            <td>{{ outboundFax.prescriberOfficesNames && outboundFax.prescriberOfficesNames.join(', ') }}</td>
            <td><app-phone-number [number]="outboundFax.fax" /></td>
            <td class="text-center">
              <div>
                @switch (outboundFax.status) {
                  @case (outboundFaxStatuses.scheduled) {
                    <span>
                      <div>Scheduled to send after {{ outboundFax.scheduledTime | date: 'M/dd h:mm a' }}</div>
                      @if (outboundFax.attemptCount > 0) {
                        <div>
                          {{ outboundFax.attemptCount }} failed send attempt{{ outboundFax.attemptCount > 1 ? 's' : '' }}
                        </div>
                      }
                    </span>
                  }
                  @case (outboundFaxStatuses.queued) {
                    <span> Sending... </span>
                  }
                  @default {
                    <span> {{ outboundFax.status | titlecase }} </span>
                  }
                }
              </div>
              <app-outbound-fax-template [outboundFax]="outboundFax" />
            </td>
            <td>
              @if (outboundFax.inboundFaxes.length > 0) {
                <div>
                  @switch (mostRecentInboundFax(outboundFax).status) {
                    @case (inboundFaxStatuses.validEvidence) {
                      <strong class="text-success">
                        Valid Fax Received
                      </strong>
                    }
                    @case (inboundFaxStatuses.notValidEvidence) {
                      <strong> Invalid Fax Received </strong>
                    }
                    @case (inboundFaxStatuses.needsManualIntervention) {
                      <strong> Manual Intervention Required </strong>
                    }
                  }
                </div>
                <div class="mt-1">
                  <a
                    target="_blank"
                    class="inbound-fax-link small"
                    routerLink="/capture-admin/communications/inbound-faxes/{{mostRecentInboundFax(outboundFax).id}}"
                    >
                    <strong>VIEW INBOUND FAX</strong>
                  </a>
                </div>
              }
            </td>
            <td>{{ keyedProviderOfficeStatusOptions[outboundFax.providerOfficeStatus]?.display }}</td>
            <td>{{ outboundFax.faxType }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (!refreshing && hasQueried && !hasResults) {
  <div class="mt-3">No Outbound Faxes Found</div>
}
@if (refreshing) {
  <div class="mt-3"><mat-spinner diameter="30" /></div>
}
